import { Ratings } from '@atlassian/amkt-common';
import { LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { UrlUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { ANALYTICS_SUBJECT_ID_RATINGS } from "../../AppHeader.constants";
import { ExternalLinkStyled, LinkStyled } from "../../AppHeader.styles";
const HeaderRatings = props => {
  const {
    appRatingLink,
    openMarketplaceLinksInNewTab,
    appKey,
    ratings
  } = props;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const onRatingsClick = () => {
    fireAnalyticsEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_RATINGS
    });
  };
  const appReviewsUrl = appRatingLink.expand({
    appKey
  });
  if (openMarketplaceLinksInNewTab) {
    return (
      /*#__PURE__*/
      React.createElement(ExternalLinkStyled, {
        href: appReviewsUrl,
        onClick: onRatingsClick
      }, /*#__PURE__*/React.createElement(Ratings, {
        ratings: ratings
      }))
    );
  }
  return /*#__PURE__*/React.createElement(LinkStyled, {
    to: UrlUtils.updateQueryParam(window.location.href, 'tab', 'reviews'),
    onClick: onRatingsClick
  }, /*#__PURE__*/React.createElement(Ratings, {
    ratings: ratings
  }));
};
export default HeaderRatings;